<template>
  <v-container fluid>

    <v-row class="fill-height" align="center" justify="center" no-gutters v-if="isAdmin || isDebugView">
      <v-col class="mx-md-1">
        <v-row class="fill-height" align="center" justify="center" no-gutters>
          <v-col class="text-center">
            <!--            <v-tooltip top>-->
            <!--              <template v-slot:activator="{ on }">-->
            <!--                  <v-icon v-on="on" color="green" class="pointer">-->
            <!--                    {{ correctIcon }}-->
            <!--                  </v-icon>-->
            <!--              </template>-->
            <!--              <span>{{ $vuetify.lang.t('$vuetify.map.travelMap.iconedTravelStats.correctDate') }}</span>-->
            <!--            </v-tooltip>-->
            {{ $vuetify.lang.t('$vuetify.map.travelMap.iconedTravelStats.startProgram') }}: {{ !debugMode ?
            travel.formattedTravelStartTime : travel.datetimestart.getTime() }}
          </v-col>
        </v-row>
        <v-row class="fill-height" align="center" justify="center" no-gutters>
          <v-col class="text-center">
            <!--            <v-tooltip top>-->
            <!--              <template v-slot:activator="{ on }">-->
            <!--                <v-icon v-on="on" color="orange" class="pointer">-->
            <!--                  {{ errorIcon }}-->
            <!--                </v-icon>-->
            <!--              </template>-->
            <!--              <span>{{ $vuetify.lang.t('$vuetify.map.travelMap.iconedTravelStats.errorDate') }}</span>-->
            <!--            </v-tooltip>-->
            {{ $vuetify.lang.t('$vuetify.map.travelMap.iconedTravelStats.startReal') }}: {{ !debugMode ?
            travel.formattedTempTravelStartTime : travel.tempStart.getTime() }}
          </v-col>
        </v-row>
        <v-row class="fill-height" align="center" justify="center" no-gutters>
          <v-col class="text-center">
            {{ $vuetify.lang.t('$vuetify.map.travelMap.iconedTravelStats.finish') }}: {{ !debugMode ?
            travel.formattedTempTravelFinishTime : travel.tempFinish.getTime() }}
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="fill-height" align="center" justify="center" no-gutters v-else>
      <v-col class="text-center">
        {{ $vuetify.lang.t('$vuetify.map.travelMap.iconedTravelStats.start') }}: {{ !debugMode ?
        travel.formattedTempTravelStartTime : travel.tempStart.getTime() }}
      </v-col>
      <v-col class="text-center">
        {{ $vuetify.lang.t('$vuetify.map.travelMap.iconedTravelStats.finish') }}: {{ !debugMode ?
        travel.formattedTempTravelFinishTime : travel.tempFinish.getTime() }}
      </v-col>
    </v-row>

    <!--    <v-row class="fill-height" align="center" justify="center" no-gutters v-if="isAdmin">-->
    <!--      <v-col class="text-center">-->
    <!--        <v-icon color="red">{{ alertIcon }}</v-icon>-->
    <!--        {{ $vuetify.lang.t('$vuetify.map.travelMap.iconedTravelStats.start') }}: {{ !debugMode ?-->
    <!--        travel.formattedTravelStartTime : travel.datetimestart.getTime() }}-->
    <!--      </v-col>-->
    <!--      <v-col class="text-center">-->
    <!--        <v-icon color="red">{{ alertIcon }}</v-icon>-->
    <!--        {{ $vuetify.lang.t('$vuetify.map.travelMap.iconedTravelStats.finish') }}: {{ !debugMode ?-->
    <!--        travel.formattedTravelFinishTime : travel.datetimefinish.getTime() }}-->
    <!--      </v-col>-->
    <!--    </v-row>-->

    <v-scroll-y-transition leave-absolute hide-on-leave>
      <div v-if="debugMode" class="text-center mt-2">
        <v-row class="fill-height" align="center" justify="center" no-gutters>
          <v-col>user_id: {{ travel.user.userId }}</v-col>
          <v-col>travel_id: {{ travel.travelId }}</v-col>
        </v-row>
        <v-row no-gutters class="fill-height mt-2" align="center" justify="center">
          <v-col>app_version: {{ travel.appVersion ? travel.appVersion.replace('\\u0027', `'`) : 'None' }}</v-col>
        </v-row>
      </div>
    </v-scroll-y-transition>

    <v-divider class="my-2"></v-divider>

    <v-row no-gutters align="center" justify="space-around">
      <v-col v-for="item in style" :key="item.postfix" md="2" cols="4"  class="px-1 mx-1 cell_width">
        <div class="text-center">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon class="pointer" left :color="item.color" v-on="on">{{ item.icon }}</v-icon>
            </template>
            <span>{{ $vuetify.lang.t(item.title) }}</span>
          </v-tooltip>
          <span class="subtitle-1 ">
            {{ item.value }}
            <v-text-field
              class="my-n2"
              v-model.number="filters[item.backend]"
              v-if="isSpecial"
              type="number" step="50" hint="ms"
              :disabled="!usedFilters.includes(item.backend)">
            </v-text-field>
            <span v-if="'postfix' in item" v-html="$vuetify.lang.t(item.postfix)"></span>
            <template
              v-if="'additionalStatisticsField' in item &&
                additionalStatistics[`_${item.additionalStatisticsField}`] !== null &&
                additionalStatistics[item.additionalStatisticsField] !== ''">

              <div class="text-center">
                {{ additionalStatistics[item.additionalStatisticsField] }}
              </div>

            </template>
          </span>
        </div>
      </v-col>
    </v-row>

    <v-divider class="mb-2 mt-2"></v-divider>

    <v-row class="fill-height" align="center" justify="space-around" no-gutters>
      <v-col v-for="item in details" :key="item.postfix" md="2" cols="5" class="text-left cell_width">
        <div class="text-center">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon class="pointer" left :color="item.color" v-on="on">{{ item.icon }}</v-icon>
            </template>
            <span>{{ $vuetify.lang.t(item.title) }}</span>
          </v-tooltip>
          <span class="subtitle-1"> {{ item.value }} <span
            v-if="'postfix' in item" v-html="$vuetify.lang.t(item.postfix)"></span></span>
        </div>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import { createHelpers } from 'vuex-map-fields'
import { Travel } from '../../../models/travel/Travel'
import { AUTH_MODULE } from '../../../store/modules'
import { mdiAccountQuestion, mdiThumbUp } from '@mdi/js'
import { TripAdditionalStatistics } from '../../../models/travel/TripAdditionalStatistics'
import { userAdditionalTripStatisticsFiltersList } from '../../../utils/travels'

const { mapFields: authFields } = createHelpers({
  getterType: `${AUTH_MODULE}/getField`
})

export default {
  name: 'iconedTravelStats',
  props: {
    travel: Travel,
    rawValues: Boolean,
    additionalStatistics: TripAdditionalStatistics,
    filters: Object
  },
  computed: {
    ...authFields(['isAdmin', 'isSpecial', 'isDebugView']),
    debugMode () {
      return (this.isAdmin || this.isDebugView) && this.rawValues
    },
    details () {
      return this.travel.route.routeState().filter(item => !item.hasOwnProperty('style'))
    },
    style () {
      return this.travel.route.routeState().filter(item => item.hasOwnProperty('style'))
    }
  },
  data: function () {
    return {
      errorIcon: mdiAccountQuestion,
      correctIcon: mdiThumbUp,
      usedFilters: userAdditionalTripStatisticsFiltersList
    }
  }
}
</script>

<style scoped>
  /*.cell_width {*/
  /*  min-width: 70px;*/
  /*}*/
</style>
